export default __webpack_public_path__ + "static/media/games-banner-id.fc2563dd.webp";